module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-4-Lets-Talk-About-Something-Else-ES-1c1cd4ef30459c9734f0764739f2a181.pdf";